module.exports = __webpack_public_path__ + "static/media/logo.390d7a31.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 258
// module chunks = 0